import React from 'react';
import { MainMenu } from 'protrans-react-ui';

function AppNavigation() {
    return (
        <MainMenu />
    )
}

export default AppNavigation;